import { ChangeDetectionStrategy, Component, effect, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { SystemSettingsStore } from './core/services/system-settings.store';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      display: flex;
      flex: 1 1 auto;
      width: 100%;
      height: 100%;
    }
  `,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private systemSettingsStore = inject(SystemSettingsStore);
  private _msalService = inject(MsalService);
  favIcon: HTMLLinkElement = document.querySelector('#favIcon');

  constructor() {
    effect(() => {
      if (this.systemSettingsStore.branding()?.favicon) {
        this.favIcon.href = this.systemSettingsStore.branding().favicon.blobUrl;
      }
    });
  }

  ngOnInit() {
    this.initializeMsal();
  }

  async initializeMsal() {
    await this._msalService.instance.initialize();
  }
}
